type FocusState =
  | 'not-focused'
  | 'editor-focused'
  | 'editor-focused-outlined'
  | 'container-focused';

type FocusEvent =
  | { type: 'keydown'; event: KeyboardEvent }
  | { type: 'pointer-focus' | 'keyboard-focus' | 'blur' };

export const focusReducer = (prev: FocusState, event: FocusEvent) => {
  switch (prev) {
    case 'not-focused':
      switch (event.type) {
        case 'pointer-focus':
          return 'editor-focused';
        case 'keyboard-focus':
          return 'editor-focused-outlined';
        default:
          return prev;
      }
    case 'editor-focused':
      switch (event.type) {
        case 'keydown':
          if (event.event.key === 'Escape') {
            return 'container-focused';
          }
          return prev;
        case 'blur':
          return 'not-focused';
        default:
          return prev;
      }

    case 'editor-focused-outlined':
      switch (event.type) {
        case 'keydown':
          if (event.event.key === 'Escape') {
            return 'container-focused';
          }
          return prev;
        case 'blur':
          return 'not-focused';
        case 'pointer-focus':
          return 'editor-focused';
        default:
          return prev;
      }
    case 'container-focused':
      switch (event.type) {
        case 'keydown':
          // event.event.stopPropagation();

          if (event.event.key === 'Shift') {
            event.event.stopPropagation();
            return prev;
          }

          if (event.event.key === 'Tab') {
            event.event.stopPropagation();
            return 'not-focused';
          }
          // } else {
          //   event.event.preventDefault();
          //   return prev;
          // }
          return 'editor-focused';
        case 'blur':
          return 'not-focused';
        case 'pointer-focus':
          return 'editor-focused';
        default:
          return prev;
      }
    default:
      return prev;
  }
};
